<template>
<div>
<ContentHeader  v-if="$store.state.sections.section"  :title="$store.state.sections.section.name"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Listeye Geri Dön" url="QuestionlistQuestions" :urlparams="headerurlparams"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">

<div class="grid">

<div class="col-12 md:col-12" v-for="item in items">
<h2>{{item.language.name}}</h2>
<ClickEditInputText  title="Soru" :value="item.translation" valkey="translation" @dataChanged="dataChanged($event,item.id)" />
<ClickEditInputTextArea  title="Yardım Metni" :value="item.description" valkey="description" @dataChanged="dataChanged($event,item.id)" />
</div>


</div>
</div>
</template>

</div>
</template>

<script>
export default {

  name: 'SectionTranslations',

  data () {
    return {
      items:[],
      loading:true
    }
  },
  computed:{
    headerurlparams()
    {
      return {id:this.$store.state.sections.section.questionlist_id}
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
        this.items = await this.generalApiGetWithoutLoader("questionlists/section/translations/"+this.$route.params.id)
        console.log(this.item)

        this.loading = await false
    },  
     dataChanged(data,id)
    {
      console.log(id);
      console.log(data)
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"questionlists/section/translations/"+id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response);      
      this.items = response.data
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>